import { useQuery } from '@tanstack/react-query';
import { getTenantDatabase } from 'api/tenantDatabases';
import { tenantDatabaseKeys } from 'api/queryKeys';

export const useTenantDatabaseQuery = (id: string | null) => {
  return useQuery({
    queryKey: tenantDatabaseKeys.detail(id ?? ''),
    queryFn: () => getTenantDatabase(id!),
    enabled: !!id
  });
};
